import { render, staticRenderFns } from "./LivingOptionEdit.vue?vue&type=template&id=53d899fa&"
import script from "./LivingOptionEdit.vue?vue&type=script&lang=js&"
export * from "./LivingOptionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports